import BaseHorseReduction from './BaseHorseReduction';
import BaseReduction from './BaseReduction';

export default class BaseHorseReductionSet extends BaseReduction {
  constructor() {
    super(...arguments);
    if (this.getNumberOfBaseHorseReductions() === 0) {
      this.addBaseHorseReduction();
      this.validate();
    }
  }

  getNumberOfBaseHorseReductions() {
    return this.getNumberOf('baseHorseReductions');
  }

  getBaseHorseReduction(index) {
    return this.getObject('baseHorseReductions', BaseHorseReduction, index);
  }

  getBaseHorseReductions() {
    return this.getObjects('baseHorseReductions', BaseHorseReduction);
  }

  addBaseHorseReduction(data) {
    this.invalidate();
    return this.addObject('baseHorseReductions', BaseHorseReduction, data);
  }

  deleteBaseHorseReduction(index) {
    this.invalidate();
    this.deleteObject('baseHorseReductions', index);

    if (this.getNumberOfBaseHorseReductions() === 0) {
      this.addBaseHorseReduction();
    }
  }

  getMaxNumberOfBaseHorseReductions() {
    return 10;
  }
}
